import * as React from 'react';
import { DomComponentProps, DomElement } from '.';

interface AccordionState {
    selectedTab?: HTMLElement;
}

export class Accordion extends React.Component<
    DomComponentProps,
    AccordionState
> {
    constructor(props: DomComponentProps) {
        super(props);
        this.state = { selectedTab: this.props.domChildSelected };
    }

    render() {
        const { selectedTab } = this.state;
        return (
            <div className="contact-choice-container contact-accordion">
                {this.props.domChildren.map((i, idx) => {
                    const link = i.dataset.link ? i.dataset.link : '#';
                    return (
                        <div
                            key={idx}
                            className={`panel ${selectedTab === i ? 'open' : ''}`}
                        >
                            <div className="accordion-title">
                                <a
                                    className={`accordion-link accordion-link--contact contact-choice__item${selectedTab ? (i === selectedTab ? ' active' : ' inactive') : ''}`}
                                    href={link}
                                    aria-expanded={
                                        selectedTab === i ? 'true' : 'false'
                                    }
                                    onClick={
                                        link == '#'
                                            ? () =>
                                                  this.setState((s) => {
                                                      return {
                                                          selectedTab:
                                                              s.selectedTab !==
                                                              i
                                                                  ? i
                                                                  : undefined,
                                                      };
                                                  })
                                            : undefined
                                    }
                                >
                                    <i
                                        className={`${i.dataset.icon || 'icon-write'} visual-icon`}
                                    ></i>
                                    <h2>{i.dataset.label}</h2>
                                    <i className="icon-angleBottom selector"></i>
                                    <i className="icon-cross selector"></i>
                                </a>
                            </div>
                            <div className="accordion-body accordion-body--contact">
                                <div className="contact-panel">
                                    <div className="contact-form">
                                        <DomElement element={i} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
